module.exports = __webpack_public_path__ + "media/images/area/feature/chubu/related/zh-hant/2-954e821bd4d90a33d51efad1a9445711.jpg";